import { type DeepPartial } from '@direct-frontend/stdlib';
import { type PromoactionModel } from './types';

export const getPromoactionDiscountTypeText = (promoaction: DeepPartial<PromoactionModel>): string => {
    const type = promoaction?.discount?.type;

    if (type === 'fixed_amount') {
        return 'Фиксированная сумма скидки';
    }

    if (type === 'percent') {
        return 'Процент от суммы покупки';
    }

    return 'Тип скидки неизвестен';
};
